/**
 * The tab title, per screen.
 *
 * The plan's own reason this app has routes at all: "a person comparing two
 * extractions will want two tabs open." Every route puts its state in the
 * URL for exactly that -- and until now every one of those tabs showed the
 * same static "explorer — parsed filings" in the switcher, which defeats
 * the point. With ten tabs open, the title bar is the only thing telling
 * them apart without clicking through each one.
 *
 * One hook, called once per route with whatever that route already has in
 * hand -- no new fetch, no new state. It restores the app's own title on
 * unmount, so navigating away (or this hook not running, on a screen that
 * has not adopted it yet) never leaves a stale title behind.
 */
import { useEffect } from 'react'

const BASE = 'explorer'

export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    const previous = document.title
    document.title = title ? `${title} — ${BASE}` : `${BASE} — parsed filings`
    return () => {
      document.title = previous
    }
  }, [title])
}
